module.exports = __webpack_public_path__ + "static/media/3d5260a1-e4cd-4567-80ed-69d23c40355f.e3b88962.woff";